exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2HdoZ{margin:20px auto}._2jIKI{background:hsla(0,0%,100%,.95);padding:40px}._2qB3U{margin-bottom:20px;font-weight:700;font-size:30px}._25OaA{margin-top:30px;margin-right:10px;background-color:#dcefed}.a5g5c{margin-top:20px}", ""]);

// exports
exports.locals = {
	"container": "_2HdoZ",
	"cardBackground": "_2jIKI",
	"heading": "_2qB3U",
	"button": "_25OaA",
	"panel": "a5g5c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/Form/Form.css
// module id = 1028
// module chunks = 0 7 9 10 11